import PaymentIframeGroupPurchasesPage from "components/GroupPurchases/PaymentIframeGroupPurchasesPage"
import BlockedPayment from "components/PurchasePage/Preview/Payment/BlockedPayment"
import FailPayment from "components/PurchasePage/Preview/Payment/FailedPage"
import { usePaymentContext } from "components/PurchasePage/Preview/Payment/PaymentContext"
import SuccessPayment from "components/PurchasePage/Preview/Payment/SuccessPayment"
import SuccessPaymentSecondary from "components/PurchasePage/Preview/Payment/SuccessPaymentSecondary"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import Loader from "components/Reusable/Loader"
import Head from "next/head"

const ENV = process.env.ENV

export enum PaymentSteps {
  PAYMENT = 1,
  FAIL = 2,
  SUCCESS = 3,
  FAILURE = 4,
  LOADER = 5,
  BLOCKED = 6,
}

const Payment = () => {
  const { paymentSteps, setPaymentSteps, setIframeLink } = usePaymentContext()
  const { groupPurchaseGuid } = usePurchaseContext()
  return (
    <>
      <Head>
        {ENV !== "production" ? (
          <>
            <script src="https://ppsuat.creditguard.co.il/plugins/applePayOnIframe.js"></script>
          </>
        ) : (
          <script src="https://pps.creditguard.co.il/plugins/applePayOnIframe.js"></script>
        )}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Head>
      {paymentSteps === PaymentSteps.PAYMENT && (
        <PaymentIframeGroupPurchasesPage />
      )}
      {paymentSteps === PaymentSteps.FAIL && (
        <FailPayment
          title="אוי.. חיוב התשלום נכשל"
          text="נראה שיש בעיה בתקשורת או באמצעי התשלום"
          link="/groupPurchases/payment"
          setPaymentSteps={setPaymentSteps}
          setIframeLink={setIframeLink}
        />
      )}
      {paymentSteps === PaymentSteps.SUCCESS &&
        (groupPurchaseGuid ? <SuccessPaymentSecondary /> : <SuccessPayment />)}
      {paymentSteps === PaymentSteps.FAILURE && (
        <FailPayment
          title="אופסי, משהו השתבש בדרך"
          text="אם הבעיה ממשיכה אפשר לפנות לשירות לקוחות."
          link="/groupPurchases/payment"
          setPaymentSteps={setPaymentSteps}
          setIframeLink={setIframeLink}
        />
      )}
      {paymentSteps === PaymentSteps.LOADER && <Loader />}
      {paymentSteps === PaymentSteps.BLOCKED && <BlockedPayment />}
    </>
  )
}

export default Payment
